module.exports = __webpack_public_path__ + "img/xacobeo-off.c0f49885.png";